module.exports = " <section id=app _v-1cf2c037=\"\"> <div class=app-content _v-1cf2c037=\"\"> <component :is=state.currentView _v-1cf2c037=\"\"></component> </div> </section> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-1cf2c037!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 181
// module chunks = 2